var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Updates-Oct-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subscriptions",
    transform: "translate(-1209.000000, -788.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 616.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1169.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71699525,0 0,6.71699525 0,15 C0,23.2830047 6.71699525,30 15,30 C23.2830047,30 30,23.2830047 30,15 C30,6.71699525 23.2830047,0 15,0 Z",
    id: "Shape-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2830047,0 30,6.71699525 30,15 C30,23.2830047 23.2830047,30 15,30 C6.71699525,30 0,23.2830047 0,15 C0,6.71699525 6.71699525,0 15,0 Z M15.1740927,8.43793314 L14.8259073,8.43791659 C13.8426795,8.44156179 8.9819336,8.47710243 7.66548158,8.82362367 C6.87789914,9.03968813 6.22924805,9.68833922 6.01318359,10.4912567 C5.66700375,11.8064118 5.63119204,14.3875081 5.62748738,14.9074539 L5.62748738,15.0929941 C5.63119204,15.6153789 5.66700375,18.2075422 6.01318359,19.5087433 C6.22947691,20.3116608 6.8625641,20.9449768 7.66548158,21.1610413 C8.99569586,21.5213247 13.8455026,21.5582769 14.8263417,21.5620669 L15.1740927,21.5620834 C16.1573205,21.5584382 21.0180664,21.5228976 22.3345184,21.1763763 C23.1374359,20.9603119 23.7705231,20.3272247 23.9868164,19.5243073 C24.3328633,18.2091522 24.3686613,15.6278719 24.3723645,15.1078881 L24.3725408,14.8530426 C24.3691307,14.2022314 24.3329015,11.7558289 23.9868164,10.4912567 C23.7705231,9.68833922 23.1374359,9.05502316 22.3345184,8.83895871 C21.0180664,8.47867525 16.1573205,8.4417231 15.1740927,8.43793314 Z M13.1316376,12.1897888 L18.0109406,15 L13.1316376,17.8102112 L13.1316376,12.1897888 Z",
    id: "Combined-Shape",
    fill: "#F45C92"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.4ca0aeb9dd25363e17d97b7c8917de2c.svg";
export { ForwardRef as ReactComponent };